<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar title="设置密码"></ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="editPassword_container">
                <div class="prompt ta-c"><span v-if="speed == 1">为了您的账号安全请验证身份</span></div>
                <van-form >
                    <ul v-if="speed == 1">
                        <li>
                            <van-field  input-align="right" name="当前手机号"   label="当前手机号"  placeholder="当前手机号" v-model="editPasswordFrom.phone" readonly ></van-field>
                        </li>
                        <li>
                            <van-field name="获取验证码"   placeholder="获取验证码" v-model="editPasswordFrom.code">
                                <template #button>
                                    <button class="btn_primary" :disabled="getCodeBtnDisabled"  @click="handleClickGetCode"><span class="line"></span>{{getCodeText}}</button>
                                </template>
                            </van-field>
                        </li>
                    </ul>

                    <ul v-else>
                        <li>
                            <van-field  input-align="right" name="密码"   label="密码" type="password"  placeholder="请输入密码" v-model="editPasswordFrom.password"  ></van-field>
                        </li>
                        <li>
                            <van-field  input-align="right" name="密码"   label="密码" type="password"  placeholder="请再次确认密码" v-model="editPasswordFrom.repassword"  ></van-field>
                        </li>
                    </ul>
                    <div class="btn_container">
                        <van-button type="info" round block @click="handleClickConfirm"  :text="speed == 1 ? '下一步' : '确定'"></van-button>
                    </div>

                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
import { SendPhoneCode,CheckVerifyCode,ResetPassword } from "@/api/index";
import ReturnNavBar from '@/components/mComponents/ReturnNavBar.vue'
import {mapState} from "vuex";
export default {
    name: 'mobileEditPassword',
    data () {
        return {
            editPasswordFrom:{
                phone:'13994804721',
                code:'',
                password:'',
                repassword:''
            },
            speed:1,
            getCodeBtnDisabled:false,
            getCodeTime:60
        }
    },
    computed: {
        ...mapState(['userInfo']),
        getCodeText() {
            if (this.getCodeBtnDisabled) {
                return `${this.getCodeTime}秒后重新发送`;
            } else {
                return '获取验证码';
            }
        },
    },
    created() {
        if(this.userInfo && this.userInfo.user){
            this.editPasswordFrom.phone = this.userInfo.user.phone
        }
    },
    mounted () {

    },
    methods: {
        // 获取验证码
        handleClickGetCode(){
            SendPhoneCode({
                phone: this.editPasswordFrom.phone,
                type: "forget"
            }).then(res => {
                if (res.code == 200) {
                    this.$toast('验证码发送成功')
                    this.getCodeBtnDisabled = true;
                    const timer = setInterval(() => {
                        if (this.getCodeTime > 0) {
                            this.getCodeTime--;
                        } else {
                            this.getCodeBtnDisabled = false;
                            clearInterval(timer);
                            this.getCodeTime = 60;
                        }
                    }, 1000);
                }
            })
        },
        handleClickConfirm(){
            if(this.speed == 1){
                if(!this.editPasswordFrom.code){
                    this.$toast('请输入验证码');
                    return false
                }
                this.$toast.loading({
                    message: '请稍后...',
                    forbidClick: true,
                    overlay:true
                });
                this.btnDisabled = true
                const data = {
                    phone: this.editPasswordFrom.phone,
                    code: this.editPasswordFrom.code,
                    type: "forget"
                }
                CheckVerifyCode(data).then(res => {
                    if (res.code == 200) {
                        this.speed = 2;
                    }
                    this.$toast.clear();
                    this.btnDisabled = false
                }).catch(() => {
                    this.$toast.clear();
                    this.btnDisabled = false
                })

            }else{
                this.btnDisabled = true;
                const data = {
                    phone: this.editPasswordFrom.phone,
                    code: this.editPasswordFrom.code,
                    password: this.editPasswordFrom.password,
                    repassword: this.editPasswordFrom.repassword
                };
                ResetPassword(data).then(res => {
                    if (res.code == 200) {
                        this.$toast({
                            message: "更换成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$router.go(-1);
                            },
                        });
                    }
                    this.btnDisabled = false;
                    this.$toast.clear();
                }).catch(() => {
                    this.btnDisabled = false
                })
            }
        },
    },
    components: {
        ReturnNavBar
    }
}
</script>

<style lang="scss" scoped>

</style>
